
//token
export const SET_TOKEN = 'SET_TOKEN';

//userInfo
export const SET_USERINFO = 'SET_USERINFO';

//show
export const SET_SHOW = 'SET_SHOW';

